// Shape returned by GET {base}/roles/:id/deletion-impact (see apps/admin-api services/userRole.ts).
export interface RoleDeletionUser {
  user_id: number
  account: string
  user_name: string
}
export interface RoleDeletionStaleUser extends RoleDeletionUser {
  repair_to_role_id: number
  repair_to_role_name: string
}
export interface RoleDeletionOrphanUser extends RoleDeletionUser {
  reason: string
}
export interface RoleDeletionImpact {
  role: { user_role_id: number; role_name: string; scope_type: string | null }
  canDelete: boolean
  activeUsers: RoleDeletionUser[]
  staleUsersToRepair: RoleDeletionStaleUser[]
  orphanUsers: RoleDeletionOrphanUser[]
}

// 刪除鈕只在 impact 已載入且後端判定可刪（沒有使用中/無法修復的帳號）時啟用；
// staleUsersToRepair 不擋——確認後後端會自動修復這些帳號的主檔角色。
export function canConfirmRoleDeletion(impact: RoleDeletionImpact | null): boolean {
  return impact != null && impact.canDelete
}
